import { UserManager } from "oidc-client-ts";
import { oauth2Config } from "./oauth2Config";

// Single shared UserManager instance. Passed to <AuthProvider userManager={...}>
// so react-oidc-context and apiConfig.ts operate on the same in-memory + sessionStorage
// state. Do not construct a second UserManager anywhere else.
export const userManager = new UserManager(oauth2Config);
